import axios from 'axios';
// import store from '@/store';
// import { getToken } from '@/utils/auth';
import { Config } from '../api/config';
import { Toast } from 'mint-ui';
import Vue from 'vue';

const restUrl = Config.restUrl
const clientId = Config.clientId
const clientSecret = Config.clientSecret

Vue.component(Toast.name, Toast);

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
});

// 判断token是否失效
// eslint-disable-next-line no-unused-vars
const checkToken = () => {
  let key = false;
  if (!localStorage.getItem('token')) {
    return true;
  }
  // eslint-disable-next-line camelcase,no-unused-vars
  const expired_time = localStorage.getItem('expired_time') || '';
  // eslint-disable-next-line camelcase
  if (expired_time) {
    // eslint-disable-next-line radix
    const nowTime = parseInt(new Date().getTime() / 1000);
    // console.log('nowTime', nowTime, 'expired_time', expired_time);
    // eslint-disable-next-line camelcase
    key = nowTime > expired_time;
  } else {
    key = true;
  }
  return key;
};

let isRefreshToken = false; // 防止同一时间段多次刷新

// 存储请求的数组
let refreshSubscribers = [];

// 将所有的请求都push到数组中,其实数组是[function(token){}, function(token){},...]
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

// 数组中的请求得到新的token之后自执行，用新的token去请求数据
function onRrefreshed(token) {
  refreshSubscribers.map((cb) => cb(token));
}

// 刷新tokens
// eslint-disable-next-line no-unused-vars
function refreshToken() {
  return new Promise((resolve, reject) => {
    axios.get(`${restUrl}oauth/access_token?client_id=${clientId}&client_secret=${clientSecret}`).then((res) => {
      console.log('刷新token', res);
      if (res.status === 200) {
        // 重新存储token和失效时间
        localStorage.setItem('token', res.data.content);
        // eslint-disable-next-line radix
        localStorage.setItem('expired_time', parseInt(new Date().getTime() / 1000) + 0.1 * 60 * 60);
        resolve();
      } else {
        if (res.data.code === 401) { // 未认证
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('token获取失败');
        }
        reject();
      }
      // eslint-disable-next-line no-unused-vars
    }).catch((error) => {
      reject();
    });
  });
}

service.interceptors.request.use(
  (req) => {
    // 登录状态
    // eslint-disable-next-line no-param-reassign
    req.headers.Authorization = 'application/json';
    // eslint-disable-next-line no-param-reassign
    req.headers.access_token = localStorage.getItem('token') || '';
    const isExpired = checkToken();
    console.log(isExpired);
    if (isExpired) { // 是否token是否过期
      console.log('zouzouzou');
      if (!isRefreshToken) { // 是否正在刷新
        console.log('zouzouzou22');
        isRefreshToken = true;
        refreshToken().then(() => {
          // 重新设置token
          const token = localStorage.getItem('token') || '';

          onRrefreshed(token);
          // eslint-disable-next-line no-const-assign
          refreshSubscribers = [];
        }).catch((error) => { // 请求失败的话重新登陆
          console.log(error);
          refreshSubscribers = [];
        }).finally(() => {
          isRefreshToken = false;
        });
      }
      /* 将请求挂起 callback回调函数执行 等待token刷新完成return promise对象 */
      // eslint-disable-next-line no-unused-vars
      const retry = new Promise((resolve, reject) => {
        subscribeTokenRefresh((token) => {
          // eslint-disable-next-line no-param-reassign
          req.headers.access_token = token;
          resolve(req);
        });
      });

      return retry;
    }
    return Promise.resolve(req);
  },
);

service.interceptors.response.use(
  // eslint-disable-next-line consistent-return
  (response) => {
    console.log('响应', response);
    return response.data;
  },
  (error) => Promise.reject(error),
);

export default service;
